import { canTrack } from '@cash-web/shared-util-can-track'

import { useRegion } from '../RegionProvider'

export function useCanTrack() {
  const regionCode = useRegion()

  return canTrack(regionCode)
}
